import { Box, SimpleGrid } from "@chakra-ui/react";

import {
  ICombined,
  IField,
  IImage,
  ILink,
  IText,
} from "../../../../../utils/types";
import { fieldComponents } from "./GuideContentBody";

import styles from "./GuideContentBody.module.scss";

interface CombinedContentProps {
  field: ICombined;
}

// Text와 Link가 섞인 경우에 대한 처리. Box로 감싸서 마진을 주기 위함
export function CombinedContent({ field }: CombinedContentProps) {
  const renderFieldItem = (
    fieldItem: IText | ILink | IImage,
    index: number
  ) => {
    const Component = fieldComponents[fieldItem.type];

    return (
      <Component
        key={index}
        field={fieldItem as IField}
        {...fieldItem.styles}
      />
    );
  };

  const renderFields = () => {
    return field.fields.map(renderFieldItem);
  };

  const renderImageFields = () => {
    return (
      <SimpleGrid
        columns={[1, 1, 2]}
        spacing="24px"
        data-testid="combined-image-fields"
        className={styles.imageGrid}
      >
        {field.fields.map(renderFieldItem)}
      </SimpleGrid>
    );
  };

  const isImageFields =
    field.fields.length === 2 &&
    field.fields.every(fieldItem => fieldItem.type === "img");

  return (
    <Box {...(field.styles?.container ?? {})}>
      {isImageFields ? renderImageFields() : renderFields()}
    </Box>
  );
}
